import { contractService } from "../../../../configs/constants";
import { message } from "antd";
import axios from "../../../../utils/axiosInceptor";
import { GET_LEASEFORMS, ADD_UNITS_VISIBLE, SET_LEAD_ID, GET_CURRENT_PAGE } from "./constants";
import { dateByformat } from "../../../../utils/dateHelper";

export const getLeaseForms =
  (
    limit,
    page = 1,
    value = "",
    field,
    setIsLoading = null,
    leaseStatus = null,
    exportData = null,
    setExportData = null,
    totalCount = null,
    startDateFrom = null,
    startDateTo = null,
    vactingDateFrom = null,
    vactingDateTo = null,
    endDateFrom = null,
    endDateTo = null,
    currentLease = false,
    leaseColumns = null,
    usagesType = null
  ) =>
  async (dispatch) => {
    let url = ``;

    let leaseTermStartDateFrom =
      startDateFrom === "" || startDateFrom === null ? "" : dateByformat(startDateFrom, "YYYY-MM-DD");
    let leaseTermStartDateTo =
      startDateTo === "" || startDateTo === null ? "" : dateByformat(startDateTo, "YYYY-MM-DD");
    let leaseTermEndDateFrom =
      endDateFrom === "" || endDateFrom === null ? "" : dateByformat(endDateFrom, "YYYY-MM-DD");
    let leaseTermEndDateTo = endDateTo === "" || endDateTo === null ? "" : dateByformat(endDateTo, "YYYY-MM-DD");
    let vacatingDateFrom =
      vactingDateFrom === "" || vactingDateFrom === null ? "" : dateByformat(vactingDateFrom, "YYYY-MM-DD");
    let vacatingDateTo =
      vactingDateTo === "" || vactingDateTo === null ? "" : dateByformat(vactingDateTo, "YYYY-MM-DD");

    let filters = {
      leaseTermStartDateFrom,
      leaseTermStartDateTo,
      leaseTermEndDateFrom,
      leaseTermEndDateTo,
      vacatingDateFrom,
      vacatingDateTo,
      usagesType,
    };
    let params = new URLSearchParams({
      ...filters,
    });

    let endPoint: any = `${contractService}/booking/findAllForLease?unitstatus=occupied&limit=${limit}&page=${page}&searchby=${field}&text=${value}&currentLease=${currentLease}&${params.toString()}`;
    if (exportData) {
      let checkedColumns = leaseColumns
        .filter((col) => col.checked && col.headerName !== "Actions")
        .map((col) => col.headerName)
        .join(", ");
      leaseStatus
        ? (url = `${endPoint}&leaseStatus=${leaseStatus}&exportData=${exportData}&columns=${checkedColumns}&totalCount=${totalCount}`)
        : (url = `${endPoint}&exportData=${exportData}&columns=${checkedColumns}&totalCount=${totalCount}`);
    } else {
      leaseStatus ? (url = `${endPoint}&leaseStatus=${leaseStatus}`) : (url = `${endPoint}`);
    }

    const {
      data: { result },
    } = await axios.get(url);
    if (result) {
      setIsLoading && setIsLoading(false);
      dispatch({
        type: GET_LEASEFORMS,
        data: result,
      });
      exportData && message.success(result);
      exportData && setExportData(false);
    }
  };
export const visiblePopup = () => (dispatch) => {
  dispatch({
    type: ADD_UNITS_VISIBLE,
    data: true,
  });
};

export const getLeadID = (leadID) => (dispatch) => {
  dispatch({
    type: SET_LEAD_ID,
    data: leadID,
  });
};

export const getCurrentPage = (currentPage) => (dispatch) => {
  dispatch({
    type: GET_CURRENT_PAGE,
    data: currentPage,
  });
};
